var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.0415H14M14 10.0415L11.2143 12.8272M14 10.0415L11.2143 7.25586",
    stroke: "#EFEFEF",
    strokeWidth: 1.39285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.47123V3.54267C14 2.51701 13.1686 1.68555 12.1429 1.68555H2.85714C1.83147 1.68555 1 2.51701 1 3.54267V16.5425C1 17.5682 1.83147 18.3996 2.85714 18.3996H12.1429C13.1686 18.3996 14 17.5682 14 16.5425V15.614",
    stroke: "#EFEFEF",
    strokeWidth: 1.39285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.901e0ba15f4ddb494ba3a16989d6c752.svg";
export { ForwardRef as ReactComponent };